module.exports = __webpack_public_path__ + "img/maj5.67d1e16f.jpg";